import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { thumbUrl } from '../utils/imageUrl';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const [added, setAdded] = React.useState(false);

  const handleAddToCart = (e) => {
    e.preventDefault();
    addToCart(product, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <Link to={`/products/${product.id}`} className="group" data-testid={`product-card-${product.id}`}>
      <div className="relative bg-white rounded-2xl overflow-hidden border border-gray-200 neon-hover hover:border-cyan-400">
        <div className="relative aspect-square overflow-hidden bg-gray-100">
          <img
            src={thumbUrl(product.image_url, 500) || 'https://via.placeholder.com/400'}
            alt={product.name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          {product.featured && (
            <div className="absolute top-2 left-2 bg-gradient-to-r from-purple-600 to-cyan-500 text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider shadow-lg">
              ★ Vedette
            </div>
          )}
          {product.stock <= 5 && product.stock > 0 && (
            <div className="absolute top-2 right-2 bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded">
              Stock limité
            </div>
          )}
          {product.stock === 0 && (
            <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
              Rupture
            </div>
          )}
        </div>

        <div className="p-4">
          <h3 className="text-gray-900 font-semibold mb-2 group-hover:text-cyan-600 transition line-clamp-2" data-testid="product-name">
            {product.name}
          </h3>
          <p className="text-gray-500 text-sm mb-4 line-clamp-2">{product.description}</p>

          <div className="flex items-center justify-between">
            <span className="text-cyan-600 font-bold text-xl group-hover:neon-text-cyan" data-testid="product-price">
              {product.price.toLocaleString('fr-DZ')} DA
            </span>
            <button
              onClick={handleAddToCart}
              disabled={product.stock === 0}
              className={`p-2 rounded-lg transition ${
                product.stock === 0
                  ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  : added
                  ? 'bg-green-500 text-white'
                  : 'bg-gradient-to-r from-cyan-500 to-purple-500 text-white hover:from-cyan-600 hover:to-purple-600 hover:neon-cyan'
              }`}
              data-testid={`add-to-cart-${product.id}`}
            >
              <ShoppingCart className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
